module.exports = __webpack_public_path__ + "img/ReschedulingAndCancellationsActive.16447150.svg";